module.exports = __webpack_public_path__ + "img/arrow-up-right.1e0b3551.svg";